module.exports = __webpack_public_path__ + "img/jbitraining_thumbnail_img@2x.46c636a7.png";